import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ITEMEDITPAGE_LEGACY_FIELD_ORDER = [
  
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  itemEditPageDescriptor: _generatedItemEditPageDescriptor,
  itemEditPageBlocDefinition,
  itemEditPageDashboardLayout,
  itemEditPageConfig,
  itemEditPageResolveConfig,
  itemEditPageProperties,
} = doodBlockConfig(
  {
    name: "Item cart edit page",
    internal_name: "Item cart edit page",
    url: "items/:itemId",
    defaultParent: [/^Main Layout$/i],
    componentType: 'ItemEditPageComponent',
    category: 'page',
    description: "Item cart edit page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.item-edit-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
      },
      {
        key: 'footer',
        name: "pages.blocks.item-edit-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["BigFooterBlock", "LegalsFooterBlock", "HtmlBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["body", "footer"],
          },
        ],
      },
    ],
  })
);

export function itemEditPageDescriptor(): IBlockDescriptor;
export function itemEditPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function itemEditPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedItemEditPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedItemEditPageDescriptor, itemEditPageProperties, fieldOrder);
}

export {
  itemEditPageBlocDefinition,
  itemEditPageDashboardLayout,
  itemEditPageProperties,
  itemEditPageConfig,
  itemEditPageResolveConfig,
};

export type ItemEditPageConfig = typeof itemEditPageConfig;
